export default "__VITE_ASSET__df075195__"